import { Badge } from '@gitbook/spine-react';

import { getTrialingBadgeProps } from '../Components';

/**
 * Compact trialing badge aligned to the end of a sidebar item.
 */
export function SidebarTrialingBadge(props: { plan: string | null }) {
    const { plan } = props;

    if (!plan) {
        return null;
    }

    return (
        <span className="ml-auto">
            <Badge
                {...getTrialingBadgeProps({
                    plan,
                    size: 'xsmall',
                    thin: true,
                })}
            />
        </span>
    );
}
